import { countPdtWishListSuccess, delPdtWishListSuccess, loadPdtWishListSuccess, savePdtWishListSuccess } from "@app/actions/shoppingmall/wishlist-pdt.action";
import { OrdPdtModel } from "@app/models/shoppingmall/order-pdt.model";
import { PdtWishListState } from "@app/selectors/shoppingmall/wishlist-pdt-selector";
import { createReducer } from "@ngrx/store";
import { on } from "@ngrx/store";

export const pdtWishListFeatureKey = "pdtWishList";

export const initialState: PdtWishListState = {
    total: 0,
    items: [] as OrdPdtModel[],
    msg: ""
}

export const pdtWishListReducer = createReducer(
    initialState,
    on(loadPdtWishListSuccess, (state, { items }) => ({...state, items : items})),
    on(countPdtWishListSuccess, (state, { total }) => ({...state, total : total})),
    on(savePdtWishListSuccess, (state, { msg }) => ({...state, msg: msg})),
    on(delPdtWishListSuccess, (state, { msg }) => ({...state, msg: msg})),
)